import { render, staticRenderFns } from "./CreateAccountDialog.vue?vue&type=template&id=c54b793a&scoped=true&"
import script from "./CreateAccountDialog.vue?vue&type=script&lang=js&"
export * from "./CreateAccountDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountDialog.vue?vue&type=style&index=0&id=c54b793a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54b793a",
  null
  
)

export default component.exports